/* @generated — do not edit directly */
// Generated by packages/schemas/scripts/generate-tool-metadata.ts

import { z } from "zod";

const knownMcpParallelSearchWebFetchToolMetadataSchema = z.object({
  iconKey: z.literal("parallelSearch"),
  input: z.object({ url: z.string() }),
  output: z.object({
    content: z.string().optional(),
    status: z.string().optional(),
    title: z.string().optional(),
    url: z.string().optional(),
  }),
});
const knownMcpParallelSearchWebSearchPreviewToolMetadataSchema = z.object({
  iconKey: z.literal("parallelSearch"),
  input: z.object({ query: z.string() }),
  output: z.object({
    results: z
      .array(
        z.object({
          title: z.string().optional(),
          url: z.string().optional(),
          excerpts: z.array(z.string()).optional(),
        }),
      )
      .optional(),
  }),
});

const knownMcpParallelSearchToolMetadataSourceSchema = z.object({
  web_fetch: knownMcpParallelSearchWebFetchToolMetadataSchema,
  web_search_preview: knownMcpParallelSearchWebSearchPreviewToolMetadataSchema,
});

export const knownParallelSearchMcpToolMetadataRegistrySchema =
  knownMcpParallelSearchToolMetadataSourceSchema.describe(
    "KnownParallelSearchMcpToolMetadataRegistry",
  );
